import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-userupdate',
  templateUrl: './userupdate.component.html',
  styleUrls: ['./userupdate.component.css']
})
export class UserupdateComponent implements OnInit {
  user: any = {};
  err: Error;
  selectedFile: File;
  constructor(private authService: AuthService,public dialogRef: MatDialogRef<UserupdateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) { }

  ngOnInit() {
    this.authService.getUserdetail().subscribe(res=>{
      this.user = res
    },err=>{
      console.log("Error", err);
    })
  }

  close(){
    this.dialogRef.close();
  }

  processFile(imageInput: any) {
    this.selectedFile = imageInput.files[0];
    console.log(this.selectedFile, imageInput);
  }

  updateUser(user){
    user.value.profile_picture = this.selectedFile;
    console.log(user.value);
    this.authService.updateUser(user.value).subscribe(res=>{
      this.dialogRef.close();
      this.router.navigateByUrl("/userdash");
    },error=>{
       this.err = error.message;
    })
  }
}
